import {
    Setting,
    SettingIdleUserTimeoutInMinutes,
    SettingScheduleType
} from 'types';

type ScheduleTypeSetting = 'queue' | 'company' | 'disabled';

export const getScheduleTypeSetting = (
    settings: Setting[]
): ScheduleTypeSetting => {
    if (!settings) {
        return 'disabled';
    }
    const scheduleType = settings.find((d) => d.key === SettingScheduleType);
    if (scheduleType) {
        return scheduleType.value as 'queue' | 'company';
    }
    return 'disabled';
};

export const getIdleTimeoutInMinutesSetting = (settings: Setting[]): number => {
    if (!settings) {
        return 0;
    }
    const itemFound = settings.find(
        (d) => d.key === SettingIdleUserTimeoutInMinutes
    );
    if (itemFound) {
        return parseInt(itemFound.value);
    }
    return 0;
};
